


































import { Component, Vue } from 'vue-property-decorator';
import {GeneralService} from '../services/general-service';
import ProgramLevel from '../components/ProgramLevel.vue';
import config from '../services/api-config';
import router from '../router';
import AuthService from '../services/auth-service';

@Component({
  components: {
      'program-level': ProgramLevel
  },
})

export default class MCQType extends Vue {
    private service = new GeneralService();
    public entities = [
        {fullName: 'All MCQs'}, {fullName: 'Past Paper MCQs'}, {fullName: 'Create Test'}
    ];
    private boards: any = [];
    private activated: boolean = false;
    private boardSelected = false;
    private level_id = JSON.parse(localStorage[config.programSelect] || null);
    private auth = new AuthService();
    public valuename: any = {};
    public storedInfo: any = [];
    public studentData: any = [];

    private selectModule(name) {
        if (name == 'All MCQs'){
            this.$router.push('/mcqsubject');
        } else if (name == 'Past Paper MCQs'){
            this.$router.push('/mcqsubject?type=pastpaper');
        } else if (name=='Create Test') {
            this.$router.push('/mcqsubject?type=customexam');
        }    
        }

    mounted() {

        if (this.level_id == '' || this.level_id == undefined || this.level_id == 'null' || this.level_id.user !== this.auth.session.userId) {
            router.push("select");
        }

        let username = this.auth.session.userName.split("@")[0];
        this.service.getInfoEMS(username).then((result) => {
            if (result && result.data && result.data.length > 0) {
                this.studentData = result.data;
                this.storedInfo = localStorage.getItem(config.studentPartInfo);
                let storedArr = typeof this.storedInfo === 'string' ? JSON.parse(this.storedInfo) : this.storedInfo;
                let currentPart = storedArr.find(p => p.fullName === this.level_id.part);
                this.valuename = currentPart ? this.studentData.find(e => e.Class === currentPart.fullName) : {};
            }
        }).catch((err) => {
            console.error('Error fetching student info:', err);
        });
    }
}
